module.exports = __webpack_public_path__ + "img/arrow-back-report.f852e9b4.svg";